export default "__VITE_ASSET__BfioHDRt__"